export interface BatchBibliographyCollectionImportRequest {
  inputFileBibliographyCollection: string
}

export function BatchBibliographyCollectionImportRequestToJSON(
  value: BatchBibliographyCollectionImportRequest
): any {
  return {
    input_file_bibliography_collection: value.inputFileBibliographyCollection
  }
}
